import Decimal from 'decimal.js';

export function toFixed(value: number | Decimal, fractionDigits = 4): string {
  // NOTE: https://stackoverflow.com/a/63988968/7920298
  const str = value.toFixed(fractionDigits, Decimal.ROUND_DOWN);
  if (fractionDigits > 0) {
    return str.replace(/(\.0+|0+)$/, '');
  }

  return str;
}

export function formatCurrency(value: Decimal | string | number, precision = 4): string {
  const fixedValue = toFixed(typeof value === 'string' ? new Decimal(value) : value, precision);

  const n = fixedValue;
  const p = n.indexOf('.');
  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => (p < 0 || i < p ? `${m},` : m));
}
